import { toast } from "react-toastify";
import { api } from "./config";
import CardDescription from "./modules/Kanban/CardDescription";
import CardTitle from "./modules/Kanban/CardTitle";
import { sub } from "date-fns";

export const renderDateFormated = (
  date: string | Date,
  long?: boolean,
  hideShowTime?: boolean
) => {
  if (long) {
    return new Intl.DateTimeFormat("pt-BR", {
      dateStyle: "full",
      timeStyle: "short",
    }).format(new Date(date));
  }
  return new Intl.DateTimeFormat("pt-BR", {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: hideShowTime ? undefined : "2-digit",
    minute: hideShowTime ? undefined : "2-digit",
  }).format(new Date(date));
};

export const customGreetings = (name = "") => {
  const myDate = new Date();
  const hours = myDate.getHours();
  if (hours >= 12 && hours <= 18) return `Boa tarde ${name},`;
  if (hours >= 18 && hours <= 24) return `Boa noite ${name},`;
  return `Bom dia ${name},`;
};

export const changeTicketStatus = async (
  status: number | string,
  ticketId: number,
  token: string,
  type: "checklist" | "measuring" | "assemble",
  reset?: boolean
) => {
  try {
    await api(token).put(`ticket/${type}/${ticketId}`, {
      status: typeof status === "string" ? status : status + 1,
      ...(reset ? { ownerId: null } : {}),
    });
    toast.success("Ticket atualizado com sucesso");
  } catch (error: any) {
    console.error(error.message);
    toast.error("Ocorreu um erro ao alterar o status do ticket");
  }
};

export const removeAllTicketEvents = async (ticketId: number, token: string) => {
  try {
    await api(token).delete(`ticket/assemble/events/${ticketId}`);
  } catch (error: any) {
    console.error(error.message);
    toast.error("Ocorreu um erro ao deletar os eventos do ticket");
  }
}

export const measuringTicketReject = async (
  token: string,
  ticketId: number
) => {
  try {
    await api(token).put(`ticket/measuring/${ticketId}`, {
      status: 2,
      rejected: true,
    });
    toast.success("Ticket rejeitado com sucesso");
  } catch (error: any) {
    console.error(error.message);
    toast.error("Ocorreu um erro ao rejeitar o ticket");
  }
};

export const measuringTicketApprove = async (
  token: string,
  fieldReportId: number
) => {
  try {
    await api(token).put(`ticket/measuring/approve/${fieldReportId}`);
    toast.success("Ticket aprovado com sucesso");
  } catch (error: any) {
    console.error(error.message);
    toast.error("Ocorreu um erro ao aprovar o ticket");
  }
};

export const capitalizeWords = (text: string) => {
  if (!text) return "";
  const words = text?.split(" ");

  const capitalizedWords = words?.map((word) => {
    const capitalizedFirstLetter = word?.charAt(0)?.toUpperCase();
    const lowercaseRestOfWord = word?.slice(1)?.toLowerCase();
    return capitalizedFirstLetter + lowercaseRestOfWord;
  });

  return capitalizedWords?.join(" ");
};

export const formatCards = (type: string, cards: any, onClick?: any) => {
  return {
    columns: cards.map((column: any) => {
      return {
        ...column,
        cards: column.cards
          .filter(({ createdAt }: any, index: number) => {
            if (type === "checklist") {
              return new Date(createdAt) > sub(new Date(), { days: 900 });
            } 
            // else if (type === "assemble" && status !== 1) {
            //   return index < 50;
            // }
            return true;
          })
          .sort((a: any, b: any) => {
            const aEvents = [...a.events ?? []]
            const bEvents = [...b.events ?? []]
            if (type === "assemble" && Boolean(a.inProgress) !== Boolean(b.inProgress)) {
              return Number(b.inProgress) - Number(a.inProgress);
            }
            if (a.status === 3 && b.status === 3) {
              if (aEvents?.reverse?.()?.[0]?.start < bEvents?.reverse?.()?.[0]?.start) {
                return -1
              } else {
                return 1
              }
            } else {
              return 0
            }
          })
          .map((card: any) => {
            const cardEvents = [...card.events ?? []]
            return {
              id: `${card.status} - ${card.id}`,
              title: (
                <CardTitle
                  id={card.id}
                  title={card.title}
                  saleDate={type === 'assemble' ? card.createdAt : card.saleDate}
                  errors={card.errors}
                  onClick={onClick}
                />
              ),
              description: (
                <CardDescription
                  type={type}
                  client={card.client}
                  seller={card.seller}
                  paymentAdditions={card.PaymentAdditions}
                  partsRequests={card.PartsRequest}
                  scheduleDate={
                    card.scheduleDate ??
                    card.startAt ??
                    card.dueDate ??
                    undefined
                  }
                  events={card.events}
                  neighbor={card.neighbor}
                  state={card.state}
                  city={card.city}
                  ownerFullName={card.owner}
                  hasAttachments={card.hasAttachments ? true : false}
                  scheduledBy={card.scheduledBy}
                  assembleType={card.type}
                  saleStatus={card.saleStatus}
                  isFullPromissory={card.isFullPromissory}
                  saleProducts={card.saleProducts}
                  owner={cardEvents?.reverse?.()?.[0]?.agenda?.title}
                  status={card.status}
                  createdAt={card.createdAt}
                  priority={card.priority ?? 2}
                  childFieldReports={card.childFieldReports}
                  lastContactAt={card.lastContactAt}
                  buildingInProgress={card.buildingInProgress}
                  minhaVisitaClientName={card.minhaVisitaClientName}
                  isUnavailableForAssemble={card.isUnavailableForAssemble}
                  assembleUnavailableReason={card.assembleUnavailableReason}
                  assemblyDate={card.assemblyDate}
                  assemblyTicket={card}
                />
              ),
            };
          }),
      };
    }),
  };
};

export const renderPercentage = (status: number) => {
  if (status === 1) return 25;
  if (status === 2) return 50;
  if (status === 3) return 75;
  if (status === 4) return 100;
  if (status === 5 || status === 6) return 85;
};

export const checkListStatusTitles: any = {
  1: "(SEC) Agendamento",
  2: "(LM) Medição",
  3: "(Proj) Aguardando Checklist",
  4: "(FIN) Checklist Concluído",
  5: "(SEC) Clientes Obras/Planta",
  6: "Ticket Cancelado",
};

export const measuringStatusTitles: any = {
  1: "Pendentes",
  2: "Medição",
  3: "Análise",
  4: "Aprovados",
  5: "Cancelados",
  6: "Em Obras",
};

export const assembleStatusTitles: any = {
  1: "Pendente Agendamento",
  2: "Aguardando Montagem",
  3: "Aguardando Análise",
  4: "Rejeitados",
  5: "Assistência Técnica",
  6: "Aguardando Peça",
  7: "Aguardando Apv. de Pagamento",
  8: "Aprovado para Pagamento",
  9: "Finalizados",
 10: "Cancelados"
};

export const TicketCategoriesMeasuring: any = {
  MEASURING_PENDING: "PENDENTES",
  MEASURING_WAITING_MEASURING: "AGUARDANDO MEDIÇÃO",
  MEASURING_WAITING_ANALYSIS: "ANÁLISE",
  MEASURING_APPROVED: "APROVADOS",
  MEASURING_CANCELLED: "CANCELADOS",
  MEASURING_WIP: "EM OBRAS",
};

export const TicketCategoriesChecklist: any = {
  CHECKLIST_WAITING_SCHEDULE: "(SEC) AGENDAMENTO",
  CHECKLIST_WAITING_MEASURING: "(LM) AGUARDANDO MEDIÇÃO",
  CHECKLIST_WAITING_CHECKLIST: "(PROJ) AGUARDANDO CHECKLIST",
  CHECKLIST_FINISHED: "(FIN) CHECKLIST CONCLUÍDO",
  CHECKLIST_NO_SHOW: "(SEC) CLIENTE EM OBRAS",
};

export const TicketCategoriesAssemble: any = {
  ASSEMBLE_PENDING_SCHEDULE: 'PENDENTE AGENDAMENTO',
  ASSEMBLE_PENDING: 'AGUARDANDO MONTAGEM',
  ASSEMBLE_WAITING_ANALYSIS: 'AGUARDANDO ANÁLISE',
  ASSEMBLE_REJECTED: 'REJEITADOS',
  ASSEMBLE_TECHNICAL_ASSISTANCE: 'ASSISTÊNCIA TÉCNICA',
  ASSEMBLE_WAITING_PARTS: 'AGUARDANDO PEÇA',
  ASSEMBLE_APPROVED: 'AGUARDANDO PAGAMENTO',
  ASSEMBLE_FINALIZED: 'FINALIZADOS',
  ASSEMBLE_CANCELLED: 'CANCELADOS',
};

export const tagColors: any = {
  descrição: "geekblue",
  status: "green",
  agendamento: "magenta",
  sistema: "cyan",
  anexo: "orange",
  ticket: "yellow",
  contact: "purple",
};

export const noRetry = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  retry: 1,
  retryDelay: 3000,
};

export const getTypeTitle = (type: "checklist" | "measuring" | "assemble") => {
  switch (type) {
    case "measuring":
      return "Medição";
    case "assemble":
      return "Montagem";
    case "checklist":
      return "Checklist";
    default:
      return "";
  }
};

export const formatNumber = (number: string | undefined): string =>
  number ? number.replace(/[^\w\s]/gi, "") : "";

export const truncateString = (str: string, size: number) => {
  if (str.length <= size) {
    return str;
  }
  return str.slice(0, size) + "...";
};

export const getInitials = (name: string) => {
  const firstLetter = name[0];
  const secondLetter = name.split(" ")[1] ?? " ";
  return `${firstLetter} ${secondLetter[0]}`;
};

export const postQuestionnaireAnswers = async (token: string, payload: any) => {
  try {
    const answersSent = await api(token).post("questionnaire-answers", payload);
    toast.success("Questionário salvo com sucesso!");
    return answersSent;
  } catch (error) {
    toast.error("Ocorreu um erro ao salvar o formulário");
    return false;
  }
};

export const printPdf = async (token: string, payload: any) => {
  try {
    const pdf = await api(token).post(
      "questionnaire-answers/exportPdf",
      payload
    );
    toast.success("PDF gerado com sucesso!");
    return pdf;
  } catch (error) {
    toast.error("Ocorreu um erro ao gerar o PDF");
    throw new Error(
      "É possível que não haja nenhuma questão salva, salve o questionário e tente novamente."
    );
  }
};

export const sendPdfByEmail = async (token: string, payload: any) => {
  try {
    await api(token).post("/questionnaire-answers/sendByEmail", payload);
    toast.success("E-mail enviado com sucesso!");
  } catch (error) {
    toast.error("E-mail não foi enviado, tente novamente mais tarde");
  }
};

export const updateUserInfo = async (
  token: string,
  userId: number,
  payload: any
) => {
  try {
    if (payload.password === "") {
      delete payload.password;
    }
    delete payload.confirmPassword;
    const updatedUser = await api(token).put(`/users/${userId}`, payload);
    toast.success("Usuário atualizado com sucesso!");
    return updatedUser;
  } catch (error) {
    toast.error("Ocorreu um erro ao Atualizar o usuário");
  }
};

export const updateManyUserInfo = async (token: string, payload: any) => {
  try {
    const updatedUsers = await api(token).put(`/users`, payload);
    toast.success("Usuários atualizados com sucesso!");
    return updatedUsers;
  } catch (error) {
    toast.error("Ocorreu um erro ao Atualizar os usuários");
  }
};

export const deleteUser = async (token: string, userId: number) => {
  try {
    await api(token).delete(`/users/${userId}`);
    toast.success("Usuário deletado com sucesso!");
  } catch (error) {
    toast.error("Ocorreu um erro ao deletar usuário");
    return false;
  }
};

export const updatePermissions = async (
  token: string,
  userId: number,
  payload: any
) => {
  try {
    const updated = await api(token).put(
      `/users/${userId}/permissions`,
      payload
    );
    toast.success("Permissões alteradas com sucesso!");
    return updated;
  } catch (error) {
    toast.error("Ocorreu um erro ao alterar as permissões");
    return false;
  }
};

export const createUser = async (token: string, payload: any) => {
  delete payload.confirmPassword;
  try {
    const updated = await api(token).post(`/users`, payload);
    toast.success("Usuário criado com sucesso");
    return updated;
  } catch (error) {
    toast.error("Ocorreu um erro ao criar o usuário");
    return false;
  }
};
export const updateClientAddress = async (
  token: string,
  ticketId: number,
  payload: any,
  type: "checklist" | "measuring" | "assemble"
) => {
  try {
    let updatedClient: any;
    if (type === "checklist") {
      updatedClient = await api(token).put(`ticket/checklist/${ticketId}`, {
        address: payload,
      });
    } else {
      updatedClient = await api(token).put(`ticket/measuring/${ticketId}`, {
        deliveryAddress: payload,
      });
    }
    toast.success("Endereço alterado com sucesso!");
    return updatedClient;
  } catch (error) {
    toast.error("Ocorreu um erro ao alterar o endereço");
    return false;
  }
};

export const updateClientInfo = async (
  token: string,
  ticketId: number,
  payload: any,
  type: "checklist" | "measuring" | "assemble"
) => {
  try {
    let updatedClient: any;
    updatedClient = await api(token).put(`ticket/${type}/${ticketId}`, {
      client: payload,
    });

    toast.success("Endereço alterado com sucesso!");
    return updatedClient;
  } catch (error) {
    toast.error("Ocorreu um erro ao alterar o endereço");
    return false;
  }
};

export const deleteFieldReport = async (
  token: string,
  fieldReportId: number
) => {
  try {
    await api(token).delete(`ticket/measuring/${fieldReportId}`);
  } catch (error) {
    toast.error("Ocorreu um erro ao deletar o ticket de medição atribuído");
  }
};

export const formatCurrency = (amount: string | number): string => {
  const parsedAmount = typeof amount === "string" ? parseFloat(amount) : amount;

  if (isNaN(parsedAmount)) {
    throw new Error("Invalid amount");
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(parsedAmount);
};

export const formatPhoneNumber = (phone: string): string => {
  if (!phone) return "";
  return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
};

export const scrollToElement = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth",
    });
  }
};
